import { get } from 'svelte/store'
import { inboxApi } from '../api'
import { settings, contacts } from '../stores'
import { createServiceWorkerKeyValueStore } from './service-worker-key-value-store.js'
import { sendMessageToAppWrapper, isInAppWrapper } from './app-wrapper-communication.js'
import { APP_WRAPPER_MESSAGE_TYPES } from '../constants.js'

export async function updateNotificationContacts () {
  const allContacts = get(contacts)

  const contactNamesObj = {}
  allContacts.forEach((contact) => { contactNamesObj[contact.id] = contact.displayName })

  const keyvalueDatabase = await createServiceWorkerKeyValueStore()
  await keyvalueDatabase.set('contacts', contactNamesObj)

  if (isInAppWrapper()) {
    sendMessageToAppWrapper({ type: APP_WRAPPER_MESSAGE_TYPES.OUTGOING.NOTIFICATION_SET_CONTACTS, value: contactNamesObj })
  }
}

export async function contactsDeferredUpdate () {
  await updateNotificationContacts()

  const allContacts = get(contacts)
  const contactIds = allContacts.map((contact) => contact.id)
  await inboxApi.accountRequests.updateContacts(contactIds)

  await settings.set('contactsChanged', false)
}
